
    const student_cities = [
    { name: 'אום אל פחם', id: "um_el_fahem"},
    { name: 'אופקים', id: "ofakim"},
    { name: 'אור יהודה', id: "oy_yehuda"},
    { name: 'אור עקיבא', id: "or_akiva"},
    { name: 'אילת', id: "eilat"},
    { name: 'אלעד', id: "elad"},
    { name: 'אריאל', id: "ariel"},
    { name: 'אשדוד', id: "ashdod"},
    { name: 'אשקלון', id: "ashqelon"},
    { name: 'באר שבע', id: "beer_sheva"},
    { name: 'בית שאן', id: "bet_shean"},
    { name: 'בית שמש', id: "bet_shemesh"},
    { name: 'ביתר עילית', id: "beitar_ilit"},
    { name: 'בני ברק', id: "bene_berak"},
    { name: 'בת ים', id: "bat_yam"},
    { name: 'גבעתיים', id: "givataim"},
    { name: 'דימונה', id: "dimona"},
    { name: 'הוד השרון', id: "hod_hasharon"},
    { name: 'הרצליה', id: "herzelia"},
    { name: 'חדרה', id: "hedera"},
    { name: 'חולון', id: "holon"},
    { name: 'חיפה', id: "haifa"},
    { name: 'טבריה', id: "tverya"},
    { name: 'טייבה', id: "taybe"},
    { name: 'טירה', id: "tira"},
    { name: 'טירת הכרמל', id: "tirat_hacarmel"},
    { name: 'טמרה', id: "tamra"},
    { name: 'יבנה', id: "yavne"},
    { name: 'יהוד', id: "yehud"},
    { name: 'ירוחם', id: "yeruham"},
    { name: 'ירושלים', id: "yerushalim"},
    { name: 'כפר סבא', id: "kfar_saba"},
    { name: 'כפר קאסם', id: "kfar_kasem"},
    { name: 'כרמיאל', id: "carmiel"},
    { name: 'לוד', id: "lod"},
    { name: 'מגדל העמק', id: "migdal_haemek"},
    { name: 'מכבים רעות', id: "maccabim_reut"},
    { name: 'מודיעין עילית', id: "modiin_ilit"},
    { name: 'מעלה אדומים', id: "maale_adumim"},
    { name: 'מעלות תרחישא', id: "maalot_tarshicha"},
    { name: 'נהריה', id: "naharya"},
    { name: 'נס ציונה', id: "nesh_tziyona"},
    { name: 'נצרת', id: "natzeret"},
    { name: 'נצרת עילית', id: "natzrat_ilit"},
    { name: 'נשר', id: "nesher"},
    { name: 'נתיבות', id: "netivot"},
    { name: 'נתניה', id: "netania"},
    { name: "סח'נין", id: "sachnin"},
    { name: 'עכו', id: "ako"},
    { name: 'עפולה', id: "afula"},
    { name: 'ערד', id: "arad"},
    { name: 'פתח תקווה', id: "petah_tikva"},
    { name: 'צפת', id: "tzefat"},
    { name: 'קלנסווה', id: "kalansua"},
    { name: 'קריית אונו', id: "kiriat_ono"},
    { name: 'קריית אתא', id: "kiriat_ata"},
    { name: 'קריית ביאליק', id: "kiriat_bialik"},
    { name: 'קריית גת', id: "kiriat_gat"},
    { name: 'קריית ים', id: "kiriat_yam"},
    { name: 'קריית מוצקין', id: "kiriat_mozkin"},
    { name: 'קריית מלאכי', id: "kiriat_malachi"},
    { name: 'קריית שמונה', id: "kiriat_shemona"},
    { name: 'ראש העין', id: "rosh_haain"},
    { name: 'ראשון לציון', id: "risho_lezion"},
    { name: 'רהט', id: "rahat"},
    { name: 'רחובות', id: "rehovot"},
    { name: 'רמלה', id: "ramla"},
    { name: 'רמת גן', id: "ramat_gan"},
    { name: 'רמת השרון', id: "ramat_hasharon"},
    { name: 'רעננה', id: "raanana"},
    { name: 'שדרות', id: "sderot"},
    { name: 'שפרעם', id: "shfaram"},
    { name: 'תל אביב יפו', id: "tel_aviv"},
];

    export default student_cities;